export const MESSAGE_TAB_SYSTEM = 'system';

export const MESSAGE_TAB_USER = 'user';

export const MESSAGE_USER_CODE_TYPE = 'usr';

export const CHAT_MESSAGES_LIMIT_PER_REQUEST = 50;
